import React from 'react';
import branding from '../data/branding';
import Profile from './Profile';

const SearchBarHeader = (props) => (

    <div className={`${props.type} ${props.background}`} >
      <div className="brisbane-logo">
        <a className="header__brisbane-logo" target="_blank" href="https://www.brisbane.qld.gov.au/" rel="follow">
          <img alt="Brisbane Logo" src="https://s3-ap-southeast-2.amazonaws.com/brisbane-images/logo/brisbane-logo.svg" />
        </a>
      </div>  

      <div className="searchBar-header-profile">
          <div className={props.specialName}>
              <a className="searchBar-header-title" target="_blank" href="https://www.brisbane.qld.gov.au/" rel="follow">
                {branding}
              </a> 
          </div>
          {props.showProfile && <Profile />}
      </div>  
    </div>

);

export default SearchBarHeader;



// WEBPACK FOOTER //
// ./src/components/SearchBarHeader.js